import { useMutation } from 'react-query'
import request from '../request'

export const useDeleteUserById = () => {
  return useMutation(({ id }: { id: string }) => {
    return request({
      url: `/admin/users/${id}`,
      method: 'DELETE',
    })
  })
}
